import { render, staticRenderFns } from "./addNewCaseDialog.vue?vue&type=template&id=6253fe32"
import script from "./addNewCaseDialog.vue?vue&type=script&lang=js"
export * from "./addNewCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports